/**
 * Created by frank.law on 1/30/18.
 */
import React from 'react';
import '../../../css/login.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';


class MessageContainer extends React.Component {

    render() {
        const {messageTitle, messageBody, iconName} = this.props;
        let icon = (iconName) ? <div className={iconName} /> : "";

        return (
            <div className="message-container">
                {icon}
                <h4 className="message-title">{messageTitle}</h4>
                <div className="message"> {messageBody}</div>
            </div>
        );
    }
}

MessageContainer.propTypes = {
    messageTitle: PropTypes.string,
    messageBody: PropTypes.string,
    iconName: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        messageTitle: state.login.messageTitle,
        messageBody: state.login.messageBody,
        iconName: state.login.iconName
    };
};

export default connect(mapStateToProps)(MessageContainer);
